import { notification } from "antd";
import {
  CREATE_FORMULAIRE_REQUEST,
  CREATE_FORMULAIRE_SUCCESS,
  CREATE_FORMULAIRE_FAILURE,
} from "../Types";
import { apiPost } from "../../services/apiInterceptor";

export const createFormulaire = (formData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_FORMULAIRE_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token
      const response = await apiPost("api/forms", formData);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Échec de la création du formulaire");
      }

      dispatch({
        type: CREATE_FORMULAIRE_SUCCESS,
        payload: data,
      });

      notification.success({
        message: "Formulaire créer avec success" || data?.status,
        duration: 5,
      });
      return data?.form;
    } catch (error) {
      dispatch({
        type: CREATE_FORMULAIRE_FAILURE,
        payload: error?.message,
      });

      notification.error({
        message: error?.message || "Échec de la création du formulaire",
        duration: 5,
      });
    }
  };
};
